export default __webpack_public_path__ + "static/media/vr-new-logo-white.184bc53b.webp";